import dayjs from "@/lib/bizday";

export const ymd = (d = new Date()) => dayjs(d).format("YYYY-MM-DD");

export const inr = (n) =>
  "₹" + new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(Math.round(Number(n) || 0));

export const inrFull = (n) =>
  "₹" + new Intl.NumberFormat("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(n) || 0);

export const fdate = (d) => (d ? dayjs(d).format("DD MMM YYYY") : "—");
// Business calendar date of a stored date/timestamp, independent of the viewer's device tz:
// date-only and offset timestamps (e.g. +05:30 midnight) keep their own calendar date; UTC values are shown in business time.
export const fbizdate = (d, tz = "Asia/Kolkata") => {
  if (!d) return "—";
  const s = String(d);
  const own = /^\d{4}-\d{2}-\d{2}($|T.*[+-](?!00:00)\d{2}:\d{2}$)/.test(s);
  const ymdStr = own ? s.slice(0, 10) : new Date(s).toLocaleDateString("en-CA", { timeZone: tz });
  return dayjs(ymdStr).format("DD MMM YYYY");
};
export const ftime = (d) => (d ? dayjs(d).format("hh:mm A") : "");
// Business-time clock (IST), independent of the viewer's device tz.
export const ftimez = ftime;
export const fdt = (d) => (d ? dayjs(d).format("DD MMM, hh:mm A") : "—");
export const fromNow = (d) => (d ? dayjs(d).fromNow?.() || dayjs(d).format("DD MMM") : "");
export const initials = (name = "") =>
  name.split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();
